"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = require("react");
const api_1 = require("@/api");
const errors_1 = require("@/common/errors");
function default_1({ userId, confirm, setDeliverySettingData, isPaymentDetail, }) {
    const [addressList, setAddressList] = (0, react_1.useState)([]);
    const resetAddress = (list) => {
        var _a;
        const hasMultipleAddress = list.length > 1;
        if (hasMultipleAddress) {
            const defaultAddressIndex = list.findIndex(data => data.is_default);
            if (defaultAddressIndex !== -1) {
                list.unshift(list.splice(defaultAddressIndex, 1)[0]);
            }
        }
        setAddressList(list);
        if (!isPaymentDetail) {
            const default_delivery = !!((_a = list[0]) === null || _a === void 0 ? void 0 : _a.is_default) ? list[0] : {};
            setDeliverySettingData(prev => (Object.assign(Object.assign({}, prev), { default_delivery })));
        }
    };
    const fetchAddressList = () => __awaiter(this, void 0, void 0, function* () {
        yield (0, api_1.getData)(`/api/v1/members/${userId}/deliveries`)
            .then(res => resetAddress(res.data.result))
            .catch(err => {
            var _a, _b, _c, _d;
            const errorStatus = (_a = err.response) === null || _a === void 0 ? void 0 : _a.status;
            const errorCode = (_d = (_c = (_b = err.response) === null || _b === void 0 ? void 0 : _b.data) === null || _c === void 0 ? void 0 : _c.meta) === null || _d === void 0 ? void 0 : _d.alert_type;
            if (errorStatus === 403)
                (0, errors_1.handle403Error)(err);
            else
                (0, errors_1.commonErrorConfirm)({ confirm, errorCode: errorCode || errorStatus });
        });
    });
    (0, react_1.useEffect)(() => {
        fetchAddressList();
    }, []);
    return [addressList, fetchAddressList];
}
exports.default = default_1;
